import request from "../utils/request";

export const reportError = async (data) => {
    return await request.post("/errorReport", data);
};

export const getErrorReports = async () => {
    return await request.get("/errorReport");
};
